import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import { actions as partnerActions, types as partnerTypes } from '../../../redux/reducers/partners';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { TParams } from '../../../redux/reducers/api-types';

interface PartnerAddManagerProps extends WithTranslation {
    match: match<TParams>;
    savePartnerManagerError: ErrorPayload;
    saveManager: (id: string, payload: any) => void;
    isSavingManager: boolean;
}

interface PartnerAddManagerState {
    formData: any;
}

class PartnerAddManagerPage extends React.Component<PartnerAddManagerProps, PartnerAddManagerState> {
    constructor(props: PartnerAddManagerProps) {
        super(props);
        const { match } = props;
        const id = match.params.id;
        this.state = {
            formData: {
                firstname: '',
                lastname: '',
                email: '',
                phone_number: '',
                partner: { id: id },
            },
        };
    }

    //========================================//
    //=============== Builders ===============//
    //========================================//

    generateInputs = (): FormDatas[] => {
        const { t } = this.props;
        const inputs: FormDatas[] = [
            {
                title: t('add_manager.title'),
                datas: [
                    { id: 'lastname', label: t('common:form.lastname'), required: true },
                    {
                        id: 'firstname',
                        label: t('common:form.firstname'),
                        required: true,
                    },
                    {
                        id: 'email',
                        label: t('common:form.email'),
                        hint: t('common:form.email_hint'),
                        type: 'email',
                        required: true,
                    },
                    {
                        id: 'phone_number',
                        label: t('common:form.phone_number'),
                        type: 'tel',
                        required: true,
                    },
                ],
            },
        ];
        return inputs;
    };

    onSubmitManager = (formData: any, event): void => {
        const { match, saveManager } = this.props;
        const id = match.params.id;

        this.setState({
            formData: formData,
        });
        saveManager(id, formData);
    };

    render() {
        const { match, savePartnerManagerError, isSavingManager } = this.props;
        const id = match.params.id;

        const formPayload = this.state.formData;

        return (
            <App needRights={{ name: AccountRight.PARTNER_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={savePartnerManagerError} />
                <EnhancedForm
                    payload={formPayload}
                    inputs={this.generateInputs()}
                    backRoute={`${paths.partners}/${id}`}
                    onSubmit={this.onSubmitManager}
                    loader={isSavingManager}
                />
            </App>
        );
    }
}

const PartnerAddManagerPageWithTranslation = withTranslation(['partner', 'common'])(PartnerAddManagerPage);

const mapStateToProps = (state) => ({
    savePartnerManagerError: errorSelectors.savePartnerManagerError(state),
    isSavingManager: pendingSelectors.isPending(state, partnerTypes.SAVE_PARTNER_MANAGER),
});

const mapDispatchToProps = {
    saveManager: partnerActions.saveManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerAddManagerPageWithTranslation);
